/* Swiss Notes — let CTA handlers run, then stop bubbling into product-card only. */
(()=>{
  if(window.SNCardActionIsolationV5)return;
  window.SNCardActionIsolationV5=true;
  const events=['pointerdown','pointerup','mousedown','mouseup','touchstart','touchend','click'];
  const bind=()=>document.querySelectorAll('.product-card__actions:not([data-sn-isolated])').forEach(actions=>{
    actions.dataset.snIsolated='1';
    events.forEach(type=>actions.addEventListener(type,e=>e.stopPropagation(),{passive:type.startsWith('touch')}));
  });
  bind();
  let queued=false;
  new MutationObserver(()=>{
    if(queued)return;
    queued=true;
    requestAnimationFrame(()=>{queued=false;bind();});
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
